var silver = "/static/7e1f1d2077ba5330.png";

export { silver as default };
//# sourceMappingURL=silver.png.js.map
